var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcOutlookCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 13.5H57.7995C59.0145 13.5 60 14.4855 60 15.7005V44.2995C60 45.5145 59.0145 46.5 57.7995 46.5H36V13.5Z",
    fill: "#3A9DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 20.937H36V44.25H57V20.937Z",
    fill: "#374251"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 60L0 53.25V6.75L34.5 0V60Z",
    fill: "#3A9DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 18.75C12.111 18.75 8.25 23.787 8.25 30C8.25 36.213 12.111 41.25 16.875 41.25C21.639 41.25 25.5 36.213 25.5 30C25.5 23.787 21.639 18.75 16.875 18.75ZM16.5 36.75C14.0145 36.75 12 33.7275 12 30C12 26.2725 14.0145 23.25 16.5 23.25C18.9855 23.25 21 26.2725 21 30C21 33.7275 18.9855 36.75 16.5 36.75Z",
    fill: "#374251"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0502 33.0833H36.0002V37.4333H40.0502V33.0833Z",
    fill: "#3A9DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3 38.3333H41.25V42.6833H45.3V38.3333Z",
    fill: "#3A9DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4668 38.3333H46.4168V42.6833H50.4668V38.3333Z",
    fill: "#3A9DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0502 27.8333H36.0002V32.1833H40.0502V27.8333Z",
    fill: "#3A9DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3 33.0833H41.25V37.4333H45.3V33.0833Z",
    fill: "#3A9DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4668 33.0833H46.4168V37.4333H50.4668V33.0833Z",
    fill: "#3A9DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6337 33.0833H51.5837V37.4333H55.6337V33.0833Z",
    fill: "#3A9DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0502 22.5H36.0002V26.85H40.0502V22.5Z",
    fill: "#3A9DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3 27.8333H41.25V32.1833H45.3V27.8333Z",
    fill: "#3A9DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4668 27.8333H46.4168V32.1833H50.4668V27.8333Z",
    fill: "#3A9DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6337 27.8333H51.5837V32.1833H55.6337V27.8333Z",
    fill: "#3A9DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3 22.5H41.25V26.85H45.3V22.5Z",
    fill: "#3A9DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4668 22.5H46.4168V26.85H50.4668V22.5Z",
    fill: "#3A9DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6337 22.5H51.5837V26.85H55.6337V22.5Z",
    fill: "#3A9DFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlookCalendar);
export default __webpack_public_path__ + "static/media/ic_outlook-calendar.a81854bba76d47faac865641e03bff2c.svg";
export { ForwardRef as ReactComponent };